import React from 'react';
import store from './Stores/SurveySectionStore'

export const SurveySectionRefProvider = ({shouldShowSectionNavPanel, children}) => {
    store.clearSectionRefs() // not really needed, but here for safety, in case of unexpected component reuse
    store.shouldShowSectionNavPanel = shouldShowSectionNavPanel
    
    return <>{children}</>
}